// extracted by mini-css-extract-plugin
export default {"old_conversation":"ChatCard_old_conversation__TC1Lu"};